import React, {useState, useEffect} from 'react';
import './App.css'

import {useLessons, useExInfo} from "./DataContext";

import {useStats} from "./StatsContext";
import {isSpeechPossible, localStorageSetItem, localStorageGetItem} from "./misc"
import ScoreBox from "./ScoreBox"

import LessonPopupMenu from "./LessonPopupMenu";

import {useServer} from "./ServerContext"

//console.log(GetChatGPTPrompt("1.16"))

function Setup({onPrefs, onWordDisplay, onTextDisplay, onRunGame, onCourse}) {
    const {isAllowedGame,isAllowedOverrideServerStats,serverSync,statsRender, coursesRender, prefsRender} = useServer();
    const {allLessons, getAllTexts, flattenTexts, courseFilenames,setBookName,bookName} = useLessons();
    const {exInfoList, exFilterTexts} = useExInfo();
    const {getExScore, removeTextsFromStats} = useStats();

    function getCourseLearned(indexLesson) {
        return JSON.parse(localStorage.getItem("coursesLearned"))?.[allLessons[indexLesson].file] || false
    }

    // Function to compute plenty of information related to a given lesson (including scores of exercises)
    // if flagSetLessonScore is set then the lesson score is set in the useState lessonScores
    const computeLessonInfos = async (indexLesson, flagSetLessonScore = false) => {

        let totalCoeff = 0;
        let lessonScore = 0;

        let lessonInfosResult = {}
        lessonInfosResult.exGroupInfoList = []

        // Loop on the exercise list
        for (const exInfo of exInfoList.current) {

            // If the lesson is not valid for this exercise, we skip the exercise
            // indexLesson ==== null ?
            if ("lessonsExcept" in exInfo && exInfo.lessonsExcept.includes(indexLesson)) continue;
            if ("lessonsOnly" in exInfo && !exInfo.lessonsOnly.includes(indexLesson)) continue;

            let lessonScoreTemp = 0;
            let n = 0;
            let min = 1000;
            let max = -1000;
            let exGroupInfoResult = {}
            exGroupInfoResult.info = exInfo
            exGroupInfoResult.choicesInfo = [] // used to store info on each choice of the exercise group
            for (const [choiceIndex, choice] of exInfo.choices.entries()) {
                const texts = exFilterSelectedTexts(exInfo, choiceIndex, indexLesson)
                if (texts.length === 0) continue

                let choiceInfoResult = {}
                choiceInfoResult.mode = (exInfo?.modes ? exInfo.modes[choiceIndex] : exInfo.group)
                choiceInfoResult.choiceIndex = choiceIndex
                const flatTexts = flattenTexts(texts)
                const score = getExScore(choice[1], choiceInfoResult.mode, flatTexts);

                choiceInfoResult.score = score;
                lessonScoreTemp += score
                n += 1
                choiceInfoResult.nFlatTexts = flatTexts.length;
                choiceInfoResult.nTexts = texts.length;
                min = Math.min(min, score)
                max = Math.max(max, score)
                exGroupInfoResult.choicesInfo.push(choiceInfoResult)
            }
            if (n !== 0) {
                lessonScore += (lessonScoreTemp / n) * exInfo.coeff
                totalCoeff += exInfo.coeff;
            }
            exGroupInfoResult.score = [min, max];
            if (exGroupInfoResult.choicesInfo.length !== 0)
                lessonInfosResult.exGroupInfoList.push(exGroupInfoResult)
        }

        lessonInfosResult.lessonScore = lessonScore / totalCoeff;

        if (indexLesson && isCourseExist(indexLesson)) {
            let courseRatio = JSON.parse(allLessons[indexLesson].courseRatio) / 100
            lessonInfosResult.lessonScore = lessonInfosResult.lessonScore * (1 - courseRatio) + courseRatio * getCourseLearned(indexLesson)
        }

        if (flagSetLessonScore) {
            setLessonScores(prev => {
                const copy = {...prev};
                copy[allLessons[indexLesson].file] = lessonInfosResult.lessonScore;
                return copy;
            });
        }
        return lessonInfosResult;
    }

    // Compute lessonScores for all the lessons --> Careful it takes time !!
    const computeLessonScores = async () => {
        console.log("WARNING : computeLessonScores");
        [...Array(allLessons.length).keys()].map(index => computeLessonInfos(index, true));
    }

    //
    // The useState and useRef variables
    //

    // useState learning mode --> use local storage
    const [learningMode, setLearningMode] = useState(() => {
        const saved = localStorageGetItem('learningMode');
        return saved || 'single';
    });
    useEffect(() => {
        localStorageSetItem('learningMode', learningMode);
    }, [learningMode]);

    // useState selected lesson --> use local storage
    const [selectedLesson, setSelectedLesson] = useState(() => {
        const saved = localStorageGetItem('selectedLesson');
        let res = 0;
        if (saved && Number.isInteger(Number(saved))) res = Number(saved);
//        if (allLessons === null || res > allLessons.length) res = 1;
        return res
    });
    useEffect(() => {
        localStorageSetItem('selectedLesson', selectedLesson);
    }, [selectedLesson]);


    // A useState to store all the texts selected of the current selected lesson
    const [allSelectedTexts, setAllSelectedTexts] = useState(null);
    useEffect(() => {
        setAllSelectedTexts(getAllTexts(selectedLesson, learningMode === "single"));
    }, [allLessons, selectedLesson, learningMode])

    // A useState to store all the lessonScores
    const [lessonScores, setLessonScores] = useState(null)
    useEffect(() => { // When allLessons change we should compute lessonScores
        if (!allLessons) return; // nothing during first render
        console.log("COMPUTE LESSON SCORES", lessonScores, JSON.stringify(localStorage.wordsStats))
        computeLessonScores()
    }, [allLessons, statsRender, coursesRender,allSelectedTexts])

    // The main useEffect to manage
    //   - server synchronization --> launched regularly
    useEffect(() => {
        if (!allLessons) return; // nothing during first render

        const sync = async () => {
            const currentUsername = localStorage.getItem("currentUsername");
            if (!currentUsername) return false;

            await serverSync();

//            setSelectedLesson(Number(localStorageGetItem("selectedLesson")));
        }

        // premier lancement immédiat
        sync();

        // programmations régulières
        let intervalId = setInterval(async () => {
            await serverSync();
        }, 10000);

        // cleanup: détruit l'interval courant quand allLessons change / unmount
        return () => {
            clearInterval(intervalId);
        };
    }, [allLessons]);

    // Compute selected lesson infos
    // It contains all the information that needs to be displayed
    const [selectedLessonInfos, setSelectedLessonInfos] = useState({});
    useEffect(() => {
            async function run() {
                let infos = await computeLessonInfos(learningMode==='single' ? selectedLesson : null)
                if (lessonScores?.[allLessons[selectedLesson].file] !== infos.lessonScore) {
                    setLessonScores(prev => {
                        const copy = {...prev};
                        copy[allLessons[selectedLesson].file] = infos.lessonScore;
                        return copy;
                    });
                }
                console.log("setSelectedLessonInfos(infos)",infos)
                setSelectedLessonInfos(infos);
            }

            if (allSelectedTexts) run();
        }, [allSelectedTexts,statsRender,coursesRender]
    )

    // A useState to monitor whether the "Cours" button should be activated or not
    const [courseButtonActive, setCourseButtonActive] = useState(false);
    useEffect(() => {
        if (!allSelectedTexts?.selectedLessonsList || courseFilenames === null) return;
        setCourseButtonActive(
            allSelectedTexts.selectedLessonsList.some(l => courseFilenames[l] !== null)
        )
    }, [allSelectedTexts, courseFilenames]);

    // A useState to keep track of which exercise is expanded on the interface
    const [expanded, setExpanded] = useState(null);
    const toggle = (jsname) => {
        setExpanded(expanded === jsname ? null : jsname);
    };

    const [exTranslationSpeechMode, setExTranslationSpeechMode] = useState(() => {
        if (localStorageGetItem("exTranslationSpeechMode") !== null)
            return JSON.parse(localStorageGetItem("exTranslationSpeechMode"));
        localStorageSetItem("exTranslationSpeechMode", "false")
        return false;
    });
    useEffect(() => {
        localStorageSetItem("exTranslationSpeechMode", JSON.stringify(exTranslationSpeechMode))
    }, [exTranslationSpeechMode])

    //
    // MORE STUFF
    //

    // Just to load the cached voice.
    isSpeechPossible();

    const isCourseExist = (indexLesson) => {
        if (allLessons === null) return false
        return (allLessons[indexLesson].file !== null)
    }

    // A simple function to get the filtered texts for a given exercise of a given lesson
    const exFilterSelectedTexts = (exInfo, choiceIndex, indexLesson = null) => {
        let allTexts = (indexLesson === null ? allSelectedTexts : getAllTexts(indexLesson, true))
        return exFilterTexts(exInfo, choiceIndex,
            allTexts?.[exInfo.choices[choiceIndex][1]]?.originalContent ?? [])
    }

    // Init a exercise choice
    const onForgetExercise = async (exGroupInfo, choiceIndex) => {
        const wst = exGroupInfo.info.choices[choiceIndex][1]
        const group = exGroupInfo.info.group;
        const texts = exFilterSelectedTexts(exGroupInfo.info, choiceIndex)
        removeTextsFromStats(wst, group, texts);
    }

    // Start Game
    const startGame = (type, choice, choiceIndex) => {
        if (!isAllowedGame) return

        const params = {
            title: type.title,
            mode: type.modes ? type.modes[choiceIndex] : type.group,
            choiceIndex: choiceIndex,
            element: type.element,
            choice: choice,
            getInfoFunctionStr: type.getInfoStr,
            texts: exFilterSelectedTexts(type, choiceIndex)
        }
        onRunGame(params);
    }


    //
    // THE HTML RENDERING CODE
    //

    // If data is not loaded we don't render anything
    if (!allLessons) return


    return (
        <div className="main-container">

            {/* --- First block  : Choose the lesson(s)--- */}

            <div className="title-container top">
                <button className="button-secondary" onClick={onPrefs} disabled={false}> 🛠️</button>
                <div className="title-container-title choix-mode-jeu-label">
                    {"Choisissez " + (learningMode === "single" ? "la leçon" : "les leçons")}
                </div>
            </div>
            <div className="section-container">
                <div className="section-container-line mode-line">
                    <div className="mode-toggle" role="group" aria-label="Mode d'apprentissage">
                        <label className="mode-option">
                            <input type="checkbox" checked={learningMode === "single"}
                                   onChange={() => setLearningMode("single")}/>
                            <span className="mode-pill">Apprentissage</span>
                        </label>
                        <label className="mode-option">
                            <input type="checkbox" checked={learningMode === "multiple"}
                                   onChange={() => setLearningMode("multiple")}/>
                            <span className="mode-pill">Révision</span>
                        </label>
                    </div>
                </div>


                <div className="section-container-line">
                    <div className="row-line">

                        <div className="row-select">
                            <LessonPopupMenu
                                allLessons={allLessons}
                                selectedLesson={selectedLesson}
                                onChange={setSelectedLesson}
                                lessonScores={lessonScores}
                                learningMode={learningMode}
                            />
                        </div>
                    </div>
                </div>
                <div className="section-container-line">
                    <button className={"lesson-button"}
                            disabled={(allSelectedTexts?.["words"] ?? []).length === 0}
                            onClick={() => onWordDisplay(allSelectedTexts["words"])}>
                        <span> 📖 </span>
                    </button>
                    <button className={"lesson-button"}
                            disabled={(allSelectedTexts?.["versions"] ?? []).length === 0}
                            onClick={() => onTextDisplay(allSelectedTexts["versions"])}>
                        <span> 🗣️ </span>
                    </button>

                    <button
                        className={`lesson-button badge-button`}
                        onClick={() => onCourse(allSelectedTexts.selectedLessonsList)}
                        disabled={!courseButtonActive}
                    >
                        <span>📚 </span>
                        {courseButtonActive && (
                            <span className={`badge ${
                                getCourseLearned(selectedLesson) ? "badge100" : ""
                            }`}>
      {getCourseLearned(selectedLesson) ? "100%" : "0%"}
    </span>
                        )}
                    </button>

                </div>
            </div>


            <div className="title-container">
                <label className="title-container-title choix-mode-jeu-label">
                    Choisissez votre exercice
                </label>
            </div>
            <span> {!isAllowedGame ? "(en attente de connexion)" : null}</span>

            <div className="exercise-list">
                {selectedLessonInfos?.exGroupInfoList?.map((exGroupInfo) => {
                    const uniqueId = `${exGroupInfo.info.jsname}-${exGroupInfo.info.group}`;
                    const isOpen = expanded === uniqueId;
                    return (
                        <div key={uniqueId} className="exercise-block-div">
                            <div className="exercise-header-div" onClick={() => toggle(uniqueId)}>
                                <span className={`arrow ${isOpen ? 'open' : ''}`}>▶</span>
                                <div className="exercise-title-container">
                                    <span className="exercise-name">{exGroupInfo.info.title} </span>
                                    {exGroupInfo.info.jsname === "ExTranslation" && exGroupInfo.info.group === "hf" ? (
                                        <button
                                            className={` ${exTranslationSpeechMode ? "active" : ""} translation-speaker-button`}
                                            onClick={(e) => {
                                                e.stopPropagation(); // éviter de plier/déplie
                                                setExTranslationSpeechMode(!exTranslationSpeechMode);
                                            }}
                                        >
                                            {exTranslationSpeechMode ? "🔊" : "🔇"}
                                        </button>
                                    ) : null}
                                </div>

                                {(exGroupInfo?.score?.[0] ?? 0) === 0 && (exGroupInfo?.score?.[1] ?? 0) === 0
                                    ?
                                    <div className={"exercise-score-div"}>
                                        ---
                                    </div>
                                    :
                                    <div className={"exercise-score-div"}>
                                        {(exGroupInfo.choicesInfo.length > 1 ?
                                            <ScoreBox score={exGroupInfo?.score?.[0] ?? 0}/> : null)}
                                        <ScoreBox score={exGroupInfo?.score?.[1] ?? 0}/>
                                    </div>}
                            </div>
                            {isOpen && exGroupInfo.choicesInfo?.length > 0 && (
                                <div className="exercise-details-div">
                                    {exGroupInfo.choicesInfo.map((choice, index) => (
                                        <div key={index} className="exercise-choice-div"
                                             onClick={() => choice.nTexts !== 0 ? startGame(exGroupInfo.info, exGroupInfo.info.choices[choice.choiceIndex], choice.choiceIndex) : null}
                                        >
                                            <div className="exercise-choice-inner">
                                                <span className="exercice-choice-name">
                                                    {exGroupInfo.info.choices[choice.choiceIndex][0] + " (" + choice.nTexts.toString() + ")"}
                                                </span>
                                                <button
                                                    className={"choice-cross-button"}
                                                    disabled={!isAllowedOverrideServerStats}
                                                    onClick={(e) => {
                                                        e.stopPropagation(); // éviter de plier/déplie
                                                        onForgetExercise(exGroupInfo, choice.choiceIndex);
                                                    }}
                                                >
                                                    🔁
                                                </button>
                                            </div>
                                            {choice.nTexts === 0 ? null :
                                                <ScoreBox score={choice.score}/>}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}


export default Setup;
